import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { ManagedSettingsPersonalHotspotComponent } from './personal-hotspot.component';

@Component({
  selector: 'ml-personal-hotspot',
  templateUrl: 'personal-hotspot.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsPersonalHotspotComponent],
})
export class ManagedSettingsPersonalHotspotContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  personalHotspot(personalHotspotEnabled: boolean) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.personalHotspot({
        udid: this.udid,
        enabled: personalHotspotEnabled,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
